const REQUEST_METHODS_ALL = {
    get: { id: 'get', name: 'GET' },
    post: { id: 'post', name: 'POST' },
    patch: { id: 'patch', name: 'PATCH' },
    put: { id: 'put', name: 'PUT' },
    delete: { id: 'delete', name: 'DELETE' },
}

const REQUEST_METHODS = {
    get: REQUEST_METHODS_ALL.get,
    post: REQUEST_METHODS_ALL.post,
}

export {
    REQUEST_METHODS,
}
